module.exports = __webpack_public_path__ + "img/6.100316bc.jpg";